import type { Site } from './sites-types.ts';
import { helloSite, pugSite, productFabricSite, internalSitesWeOwn } from './sites.ts';

export const internalSites: ReadonlyArray<Site> = [
  helloSite,
  pugSite,
  productFabricSite,
  ...internalSitesWeOwn,
];
